import { FormErrors } from 'modules/core/hooks/useForm'
import i18n from 'modules/core/lib/i18n'

import { LineItemWithComplianceExtraFieldsFormFields } from 'modules/finance/components/Invoices/SaleInvoicesUpsertSidepanel/SaleInvoiceForm/types'

export function validateLineItem(
  values: LineItemWithComplianceExtraFieldsFormFields
): FormErrors<LineItemWithComplianceExtraFieldsFormFields> {
  const errors: FormErrors<LineItemWithComplianceExtraFieldsFormFields> = {}
  if (!values.lineItem.description) {
    errors.lineItem = {
      ...errors.lineItem,
      description: i18n.t('finance.sale_invoices.form.error_required'),
    }
  }
  if (!values.lineItem.quantity || values.lineItem.quantity == 0) {
    errors.lineItem = {
      ...errors.lineItem,
      quantity: i18n.t('finance.sale_invoices.form.error_one_or_higher'),
    }
  }
  if (!values.lineItem.amount || values.lineItem.amount < 0) {
    errors.lineItem = {
      ...errors.lineItem,
      amount: i18n.t('finance.sale_invoices.form.error_required'),
    }
  }
  if (!values.lineItem.taxRate) {
    errors.lineItem = {
      ...errors.lineItem,
      taxRate: i18n.t('finance.sale_invoices.form.error_required'),
    }
  }
  return errors
}
